import e from "prop-types";
const s = e.shape({
  day: e.number.isRequired,
  month: e.number.isRequired,
  year: e.number.isRequired
}), i = e.shape({
  month: e.number.isRequired,
  year: e.number.isRequired
}), r = e.oneOfType([s, i]), o = e.shape({
  label: e.string.isRequired,
  value: e.string.isRequired,
  startDate: r.isRequired,
  endDate: r.isRequired
});
export {
  r as a,
  o as b,
  s as d,
  i as m
};
